import { XHR_BOX_FILTER_STRATEGY_NAME, XHR_BOX_RECENT_STRATEGY_NAME } from './xhr_box_constants';

import filterBoxRenderStrategy from './filter_render_strategy';
import recentBoxRenderStrategy from './recent_render_strategy';

export const BOX_RENDER_STRATEGIES = {
    [XHR_BOX_RECENT_STRATEGY_NAME]: recentBoxRenderStrategy,
    [XHR_BOX_FILTER_STRATEGY_NAME]: filterBoxRenderStrategy
};
